var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zM8.748 17.148L4.44 12.84a1.195 1.195 0 010-1.692 1.195 1.195 0 011.692 0L9.6 14.604l8.256-8.256a1.195 1.195 0 011.692 0 1.195 1.195 0 010 1.692l-9.108 9.108a1.195 1.195 0 01-1.692 0z",
    fill: "#4CAF50"
  })));
}
export default SvgGreenCheck;